"use client";

import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { useTranslations } from "next-intl";
import { Icon } from "@/components/ui/Icon";
import { Link } from "@/i18n/navigation";
import { useCart } from "./CartContext";
import { useInCartCount } from "./use-in-cart-count";

/**
 * The card button for a product that must be configured on its own page. It
 * still leads there, since each configuration is its own line; once any of it is
 * in the cart it says so, so the card does not look like one never added.
 */
export function ChooseOptionsLink({ productId, href }: { productId: string; href: string }) {
	const t = useTranslations("shop");
	const { viewOnly } = useCart();
	// Hidden on a browse-only store, like the card's stepper and the page's line.
	const count = useInCartCount(productId);
	const inCart = viewOnly ? 0 : count;
	return (
		<Link
			href={href}
			className={`btn relative w-full px-2 text-xs sm:text-sm ${inCart > 0 ? "border border-primary text-primary" : "btn-outline"}`}
		>
			{t("choose")}
			{/* A corner bubble, not inline: a narrow card has no width to spare
			    beside the label. */}
			{inCart > 0 && (
				<span className="absolute -top-2 -end-2 inline-flex h-5 min-w-5 items-center justify-center gap-0.5 rounded-full bg-primary px-1.5 text-[11px] font-bold text-primary-foreground tabular-nums shadow-sm">
					<Icon icon={faCheck} size={9} />
					<span className="sr-only">{t("inCartCount", { n: inCart })}</span>
					<span aria-hidden>{inCart}</span>
				</span>
			)}
		</Link>
	);
}
